export const CORE_HOTELS_NAME = "core-hotels";

export enum CoreHotelsComponent {
  HotelBreadcrumbs = "HotelBreadcrumbs",
  //Availability
  Search = "Search",
  GuestPicker = "GuestPicker",
  GuestCountPicker = "GuestCountPicker",
  ChildAgePicker = "ChildAgePicker",
  HotelLocationAutocomplete = "HotelLocationAutocomplete",
  DateRangePicker = "DateRangePicker",
  HotelSearch = "HotelSearch",
  HomePageHotelSearch = "HomePageHotelSearch",
  HotelListLoading = "HotelListLoading",
  HotelAvailabilityTitle = "HotelAvailabilityTitle",
  HotelListSort = "HotelListSort",
  HotelListError = "HotelListError",
  HotelList = "HotelList",
  HotelListItem = "HotelListItem",
  HotelListNoHotels = "HotelListNoHotels",
  Filters = "Filters",
  FilterDialog = "FilterDialog",
  FilterList = "FilterList",
  StayTypeFilter = "StayTypeFilter",
  HotelAvailabilitySearch = "HotelAvailabilitySearch",
  HotelAvailabilityMap = "HotelAvailabilityMap",
  HotelMapMarkers = "HotelMapMarkers",
  HotelMapClusters = "HotelMapClusters",
  HotelMapRedoSearchButton = "HotelMapRedoSearchButton",
  /**
   * Optional banner rendered above the hotel list on the availability page.
   * Use to inject contextual content (e.g. offers, promotions) above search results.
   */
  HotelAvailabilityBanner = "HotelAvailabilityBanner",
  /**
   * Optional banner rendered in the room selection section, above the rooms.
   */
  HotelRoomSelectionBanner = "HotelRoomSelectionBanner",

  //Shop
  /**
   *  Optional header rendered between the image gallery and hotel info section.
   *  Use to inject contextual content (e.g. package pricing) above hotel details.
   */
  HotelShopHeader = "HotelShopHeader",
  AboutHotelSection = "AboutHotelSection",
  Amenities = "Amenities",
  AmenityIcon = "AmenityIcon",
  CheckInPoliciesSection = "CheckInPoliciesSection",
  CheckInInformationSection = "CheckInInformationSection",
  CustomerReview = "CustomerReview",
  CustomerReviewsSection = "CustomerReviewsSection",
  HotelShopSection = "HotelShopSection",
  HotelShopMap = "HotelShopMap",
  HotelInfoSection = "HotelInfoSection",
  HotelShopPrice = "HotelShopPrice",
  HotelShopBookingSection = "HotelShopBookingSection",
  HotelRoomCard = "HotelRoomCard",
  HotelRoomCardRates = "HotelRoomCardRates",
  HotelRoomRate = "HotelRoomRate",
  HotelRoomSelection = "HotelRoomSelection",
  HotelRoomCardDialog = "HotelRoomCardDialog",
  HotelShopSearch = "HotelShopSearch",
  ImageGallery = "ImageGallery",
  HotelsFintechMarketplacePageWrapper = "HotelsFintechMarketplacePageWrapper",
  HotelsFintechMarketplacePageInfoHeader = "HotelsFintechMarketplacePageInfoHeader",
  HotelRoomSelectionSection = "HotelRoomSelectionSection",

  //Pages
  SearchPage = "SearchPage",
  AvailabilityPage = "AvailabilityPage",
  ShopPage = "ShopPage",
  RoomSelectionPage = "RoomSelectionPage",
  HotelReservationPage = "HotelReservationPage",

  //Images Carousel
  ImageCarouselArrow = "ImageCarouselArrow",
  ImageCarouselImage = "ImageCarouselImage",
  ImageCarousePlaceholder = "ImageCarousePlaceholder",
  ImageCarousel = "ImageCarousel",

  // Price subcomponent
  HotelPrice = "HotelPrice",

  //Hotel Card
  HotelCard = "HotelCard",
  HotelCardTags = "HotelCardTags",
  HotelCardAmenities = "HotelCardAmenities",
  HotelCardRating = "HotelCardRating",
  HotelCardDealTag = "HotelCardDealTag",
  HotelCardFeatures = "HotelCardFeatures",
  HotelCardPrice = "HotelCardPrice",
  HotelCardLocation = "HotelCardLocation",
  HotelCardNotAvailableTag = "HotelCardNotAvailableTag",
  TripAdvisorRating = "TripAdvisorRating",
  HotelLink = "HotelLink",

  //Common
  HotelPriceBreakdown = "HotelPriceBreakdown",

  //Filters
  FilterRating = "FilterRating",
  FilterCancellation = "FilterCancellation",
  FilterPayLater = "FilterPayLater",
  FilterAmenity = "FilterAmenity",
  FilterRatingHorizontal = "FilterRatingHorizontal",
  HotelNameFilter = "HotelNameFilter",
  MealPlanFilter = "MealPlanFilter",
  FilterUserRating = "FilterUserRating",

  //Checkout
  HotelReviewPageContent = "HotelReviewPageContent",
  HotelCheckoutCard = "HotelCheckoutCard",

  //Post booking
  HotelReservationCard = "HotelReservationCard",
  HotelReservationHeader = "HotelReservationHeader",
  HotelReservationProduct = "HotelReservationProduct",
  HotelReservationDetails = "HotelReservationDetails",
  HotelReservationPayment = "HotelReservationPayment",

  //Map
  HotelMapCard = "HotelMapCard",
  AvailabilityMapDialog = "AvailabilityMapDialog",

  // Cancellation Policy
  LodgingCancellationPolicyPopup = "LodgingCancellationPolicyPopup",
}
